import { createGlobalStyle } from "styled-components";
import bg from "../assets/background.jpg";
import darkbg from "../assets/darkbackground.webp";

type GlobalProps = {
	darkMode: "dark" | "light";
};

export default createGlobalStyle<GlobalProps>`
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
  font-family: "Salsa", cursive;
	vertical-align: baseline;
    box-sizing: border-box;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
html {

}

body {
	background: url(${(props) => (props.darkMode === "dark" ? darkbg : bg)});
	background-size: ${(props) => (props.darkMode === "dark" ? "400px" : "")};
	background-repeat: repeat;
  background-position: top ${(props) => (props.darkMode === "dark" ? "270.5px" : "240px")} center;
  background-attachment: fixed;
  transition: 1s;
	line-height: 1;

}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}

button {
  cursor: pointer;
}

:root {
  --darkBlue: #334060;
	--grey100: #565656;	
  --grey50:  ${(props) => (props.darkMode === "dark" ? "#bcbcbc" : "#ebebeb")};
  --textShadowWhite: 2px 0 0 white, -2px 0 0 white,
		0 2px 0 white, 0 -2px 0 white, 1px 1px white,
		-1px -1px 0 white, 1px -1px 0 white,
		-1px 1px 0 white;
    --textShadowBlack: 2px 0 0 black, -2px 0 0 black,
		0 2px 0 black, 0 -2px 0 black, 1px 1px black,
		-1px -1px 0 black, 1px -1px 0 black,
		-1px 1px 0 white;
	--green50: ${(props) => (props.darkMode === "dark" ? "#334060" : "#bbdfd1")};
	--green100: ${(props) => (props.darkMode === "dark" ? "#334060" : "#9ad5ad")};
  --blue150: #bbdfd1;
  --blue100: #095a79;
  --blue50: ${(props) => (props.darkMode === "dark" ? "#F4AC1C" : "#85BB41")};
  --blue: #81C3CF;
  --white: #ffffff;
  --orange: ${(props) => (props.darkMode === "dark" ? "#81C3CF" : "#F4AC1C")};
  --orange50: #f8c865;
  --whiteSection: ${(props) => (props.darkMode === "dark" ? "#334060" : "#ffffff")};
  
}
#scrollToTop:hover {
  border: 2px solid var(--blue50) !important;
		color: var(--blue50);
}

/* ===== Scrollbar CSS ===== */
  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: var(--blue50) black;
  }

  /* Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 10px;
  }

  *::-webkit-scrollbar-track {
    background: black;
  }

  *::-webkit-scrollbar-thumb {
    background-color: var(--blue50);
    border-radius: 10px;
    border: 3px solid black;
  }


  a {
   
    text-decoration: none;
    color: inherit;
  }
  a:visited {
    text-decoration: none;
  }

  input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
`;
